import { metaData } from '@cornerstonejs/core';
import { logging } from '@cornerstonejs/metadata';
const log = logging.loaderLog.getLogger('getInstanceModule');
function getInstanceModule(imageId, metaDataProvider, types) {
    const result = {};
    for (const t of types) {
        try {
            const data = metaDataProvider(t, imageId);
            if (data) {
                const capitalizedData = {};
                for (const key in data) {
                    if (key in data) {
                        const capitalizedKey = metaData.toUpperCamelTag(key);
                        capitalizedData[capitalizedKey] = data[key];
                    }
                }
                Object.assign(result, capitalizedData);
            }
        }
        catch (error) {
            log.error(`Error retrieving ${t} data:`, error);
        }
    }
    return result;
}
const instanceModuleNames = [
    'multiframeModule',
    'generalSeriesModule',
    'patientStudyModule',
    'imagePixelModule',
    'modalityLutModule',
    'voiLutModule',
    'sopCommonModule',
    'petIsotopeModule',
    'overlayPlaneModule',
    'transferSyntax',
    'petSeriesModule',
    'petImageModule',
];
export { getInstanceModule, instanceModuleNames };
